/**
 * v-hasPermi 操作权限处理
 * Copyright (c) 2019 ruoyi
 */

import store from '@/store'

export default {
  inserted(el, binding, vnode) {
    const {value} = binding
    const all_permission = "*:*:*";
    const permissions = store.getters && store.getters.permissions

    if (value && value instanceof Array && value.length > 0) {
      const permissionFlag = value
      const hasPermissions = permissions.some(permission => {
        return  permissionFlag.includes(permission.trim())
      })
      if (!hasPermissions) {
        el.classList.add('is-disabled')
        el.style.cursor='not-allowed'
        el.disabled='disabled'
        if(el.children){
          el.firstChild.disabled=true
          // el.firstChild.setAttribute('aria-disabled',true)
          //todo 开关点击禁用看下
        }
        // el['aria-disabled']=true
        // el['aria-disabled']=true
        // el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      throw new Error(`请设置操作权限标签值`)
    }
  }
}



// WEBPACK FOOTER //
// ./src/directive/permission/hasPermi.js